module.exports = __webpack_public_path__ + "static/media/configurator-home-img.5a09fc40.svg";